import React from 'react';
import css from './index.module.scss';
import { Warning } from '../../../components/Icons';
import PHLogo from '../../../brands/phd/logo';
import LightningProcessingLoader from './assets/lightningpayloader.gif';
import { FormattedMessage } from 'react-intl';
import LightningIcon from '../../../components/Icons/Lightning/Lightning_icon.svg';

const LightningPayProcessing = ({ isDesktop }) => {
  return (
    <div className={css.root}>
      {/* {isDesktop && (
        <div className={css.badgeContainer}>
          <Badge />
        </div>
      )} */}
      <div className={css.kfcLogo}>
        <PHLogo />
      </div>
      <div className={css.lightningPayProcessCont}>
        <div className={css.icon}>
          <img src={LightningIcon} alt="Lightning Pay Icon" />
        </div>
        <div className={css.text}>
          <FormattedMessage id="lightning_pay_title" defaultMessage="Lightning pay" />
        </div>
      </div>
      <img src={LightningProcessingLoader} alt="Loader" className={css.loader} />
      <div className={css.processingText}>
        {' '}
        <FormattedMessage id="lihgtning_pay_processing_title" />
      </div>
      <div className={css.descriptionText}>
        <FormattedMessage id="lihgtning_pay_processing_description" />{' '}
        <span role="img" aria-label="face">
          🤖
        </span>
      </div>
      <div className={css.warningContainer}>
        <div className={css.warningIcon}>
          <Warning fill={'#FA6400'} />
        </div>
        <div className={css.warningText}>
          <FormattedMessage id="lihgtning_pay_processing_donot_close" />
        </div>
      </div>
    </div>
  );
};
export default LightningPayProcessing;
